import { useEffect } from 'react';
import { frontendActions, OPEN_SELF_URL_TARGET } from '@cmctechnology/webinvest-store-frontend';
import { useLocation } from 'react-router';
import { Theme, themeConfig, THEMES } from '@cmctechnology/webinvest-constants';
import { useMobileDetect } from '@cmctechnology/webinvest-design-system';

const DEFAULT_THEME = THEMES.CMC;

export const RedirectToMobileApp = () => {
  const location = useLocation();
  const { isIos } = useMobileDetect();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const theme = searchParams.get('theme');
    const config = themeConfig[(theme as Theme) ?? DEFAULT_THEME] ?? themeConfig[DEFAULT_THEME];
    const path = isIos ? config!.mobileAppLinks.appStore : config!.mobileAppLinks.googlePlayStore;

    frontendActions.redirectToUrl(path, OPEN_SELF_URL_TARGET);
  }, []);

  return <></>;
};
